// @ts-nocheck

import React from 'react';
import { connect } from 'react-redux';
import Head from 'react-helmet';
import map from 'lodash/map';
import styled from 'styled-components';

import states from 'app/shared/utils/states';
import Container from 'app/shared/core/Container';
import Title from 'app/shared/modules/Title';
import Section from 'app/shared/modules/Section';
import Linker from 'app/shared/modules/Linker';

const StateLinkItem = styled.li`
  line-height: 30px;
  padding-left: 12px;
`;

class SitemapPage extends React.Component {
  constructor(props) {
    super(props);
  }

  getMetaContent = () => {
    const meta = [
      {
        name: 'description',
        content: 'Browse HotPads sitemap to find apartments and houses for rent in every city and state across the US.',
      },
      {
        'http-equiv': 'pragma',
        content: 'no-cache',
      },
      {
        'http-equiv': 'expires',
        content: 'no-cache',
      },
      {
        'http-equiv': 'expires',
        content: '0',
      },
      { property: 'og:title', content: 'HotPads Sitemap, Apartments and Houses For Rent | HotPads' },
      {
        property: 'og:description',
        content: 'Browse HotPads sitemap to find apartments and houses for rent in every city and state across the US.',
      },
      { property: 'og:url', content: 'https://hotpads.com/directory-sitemap' },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: 'HotPads' },
      {
        property: 'og:image',
        content: 'http://filenet.hotpads.com/images/logos/logo_square.png',
      },
    ];

    const title = 'HotPads Sitemap, Apartments and Houses For Rent | HotPads';

    return {
      meta,
      title,
    };
  };
  render() {
    const metaContent = this.getMetaContent();

    return (
      <Container>
        <div className="SitemapPage">
          <Head meta={metaContent.meta} title={metaContent.title} />
          <Section>
            <Title size="lg">HotPads Sitemap - Browse rental listings near me or by state, city, and type</Title>
          </Section>
          <Section>
            <Title size="md" htmlTag="h2">
              Near Me
            </Title>
          </Section>
          <ul>
            <StateLinkItem>
              <Linker to="/rentals-near-me">Rentals Near Me</Linker>
            </StateLinkItem>
            <StateLinkItem>
              <Linker to="/homes-for-rent-near-me">Homes for Rent Near Me</Linker>
            </StateLinkItem>
            <StateLinkItem>
              <Linker to="/places-for-rent-near-me">Places for Rent Near Me</Linker>
            </StateLinkItem>
            <StateLinkItem>
              <Linker to="/cheap-apartments-near-me">Cheap Apartments Near Me</Linker>
            </StateLinkItem>
            <StateLinkItem>
              <Linker to="/1-bedroom-apartments-near-me">1 Bedroom Apartments Near Me</Linker>
            </StateLinkItem>
          </ul>
          <Section>
            <Title size="md" htmlTag="h2">
              State
            </Title>
          </Section>
          <ul>
            {map(states, (state) => {
              return (
                <StateLinkItem key={state.name}>
                  <Linker to={`/${state.resourceId}`} key={state.name}>
                    {state.name}
                  </Linker>
                </StateLinkItem>
              );
            })}
          </ul>
        </div>
      </Container>
    );
  }
}

export default connect()(SitemapPage);
